import { ElementRef, EventEmitter, Injectable } from "@angular/core";
import {
  Alert,
  AlertController, Content, Loading, LoadingController, Platform,
  ToastController
} from "ionic-angular";
import { TranslateService } from "@ngx-translate/core";
import { NavigationHelper } from "./navigation.helper";
import { Keyboard } from "@ionic-native/keyboard";
import { Observable } from "rxjs";
import { merge } from "rxjs/observable/merge";
import { mapTo } from "rxjs/operators";

@Injectable()
export class IonicHelper {
  
  loaderInstance: Loading = null;
  
  public isMobile: boolean;
  public keyboardShown$: Observable<boolean>;
  
  constructor(private alertController: AlertController, 
              private toastController: ToastController,
              private loadingController: LoadingController, 
              private translator: TranslateService,
              private navigationHelper: NavigationHelper,
              private keyboard: Keyboard,
              public platform: Platform) {

    this.isMobile = ((this.platform.is('mobile') || this.platform.is('mobileweb')) && !(this.platform.is('tablet') || this.platform.is('core')));

    this.keyboardShown$ = merge(
      this.keyboard.onKeyboardWillShow().pipe(mapTo(true)),
      this.keyboard.onKeyboardWillHide().pipe(mapTo(false))
    );



  }
  
  
  public alert(message: any = '', title: any = 'GLOBAL.OOPS'): EventEmitter<void> {
    
    let messsageStr;
    if(typeof message === 'object'){
       messsageStr = this.translator.instant(message.message, message.context);
    }
    else {
      messsageStr = this.translator.instant(message);
    }
    
    let titleStr;
    if(typeof title === 'object'){
       titleStr = this.translator.instant(title.message, title.context);
    }
    else {
      titleStr = this.translator.instant(title);
    }
    
    let onConfirm: EventEmitter<void> = new EventEmitter();
    
    let alert = this.alertController.create({
      title: titleStr,
      subTitle: messsageStr,
      buttons: [
        {
          text: 'OK',
          handler() {
            onConfirm.emit();
          }
        }
      ]
    });
    alert.present();
    
    return onConfirm;
    
  }
  
  
  public uncloseableAlert(message: any = '', title: any = 'GLOBAL.OOPS', translate: boolean = true): Alert {
    
    let messsageStr;
    let titleStr;
    
    if(translate){
      if(typeof message === 'object'){
         messsageStr = this.translator.instant(message.message, message.context);
      }
      else {
        messsageStr = this.translator.instant(message);
      }
      
      if(typeof title === 'object'){
         titleStr = this.translator.instant(title.message, title.context);
      }
      else {
        titleStr = this.translator.instant(title);
      }
      
    }
    else {
      messsageStr = message;
      titleStr = title;
    }
        
    let alert = this.alertController.create({
      title: titleStr,
      subTitle: messsageStr,    
      enableBackdropDismiss: false
    });
    alert.present();
    
    return alert;
    
  }
   
  
  public uncoverableErrorAlert(message: any = '', navigateTo: string = 'dashboard') {
    this.alert('GLOBAL.ERRORS.'+message).subscribe(() => {
        this.navigationHelper.getRootNav().setRoot(navigateTo);
    });
  }
  
  public confirm(message: any = '', title: any = 'GLOBAL.ARE_YOU_SURE', confirmBtnStr: string ='GLOBAL.OK', cancelBtnStr: string = 'GLOBAL.CANCEL'): EventEmitter<boolean> {
    
    let messsageStr;
    if(typeof message === 'object'){
       messsageStr = this.translator.instant(message.message, message.context);
    }
    else {
      messsageStr = this.translator.instant(message);
    }
    
    let titleStr;
    if(typeof title === 'object'){
       titleStr = this.translator.instant(title.message, title.context);
    }
    else {
      titleStr = this.translator.instant(title);
    }
    
    
    let onAction: EventEmitter<boolean> = new EventEmitter();
    
    let confirm = this.alertController.create({
      title: titleStr,
      subTitle: messsageStr,
      cssClass: "custom-ionic-alert",
      buttons: [
        {
          text: this.translator.instant(cancelBtnStr),
          role: 'cancel',
          cssClass: 'btn--cancel',
          handler() {
            onAction.emit(false);
          }
        },
        {
          text: this.translator.instant(confirmBtnStr),
          handler() {
            onAction.emit(true);
          }
        },
      ]
    });
    confirm.present();
    
    return onAction;
    
  }
  
  public toast(message: any = ''): EventEmitter<void> {
    
    let messsageStr;
    if(typeof message === 'object'){
       messsageStr = this.translator.instant(message.message, message.context);
    }
    else {
      messsageStr = this.translator.instant(message);
    }
    
    let onDismiss: EventEmitter<void> = new EventEmitter();
    
    let toast = this.toastController.create({
      message: messsageStr,
      duration: 3000,
      position: 'bottom',   
      cssClass: "toast--green",   
      showCloseButton: true,
      closeButtonText: "×"
    });
    toast.onDidDismiss(() => {
      onDismiss.emit();
    });
    
    toast.present();
    
    return onDismiss;
    
  }
  
  public invalidFieldsAlert(messageBefore?: string, messageAfter?: string, errorMessagesPath: string = '', invalidFields: string[] = [], title: any = 'GLOBAL.OOPS'): EventEmitter<void> {
    
    let allErrorMsgs = this.translator.instant(errorMessagesPath);
    
    let errMsgStr = '';
    
		if(messageBefore) errMsgStr += this.translator.instant(messageBefore);
		
		errMsgStr += '<ul class="list-left my-3">';		
		
    for(let invalidField of invalidFields){  
      if(allErrorMsgs[invalidField]) {
        errMsgStr += '<li>' + allErrorMsgs[invalidField] + '</li>';
      }
    }
    errMsgStr += '</ul>';
    
    if(messageAfter) errMsgStr+= this.translator.instant(messageAfter);
    
    return this.alert(errMsgStr, title);
    
  }
  
  
  public toggleLoader(show: boolean = true){
    
    if(show) {
        this.loaderInstance = this.loadingController.create();
        this.loaderInstance.present();
    }
    else {
      if(this.loaderInstance){
        this.loaderInstance.dismiss();
        this.loaderInstance = null;
      }
    }
    
    
  }
  
  public detectIE() {
    const ua = window.navigator.userAgent;
    
    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        return true;
    }
  
    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      return true;
    }
  
    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
      return false;
    }
  
    // other browser
    return false;    
  }
  
  
  public elementIsInView (elementRef: ElementRef, container: Content = null) {
    
    let elementPosition = this.getElementPos(elementRef);
    
    if(container === null){
      let supportPageOffset = window.pageXOffset !== undefined;
      let isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
      let supportWindowDimensions = window.innerHeight !== undefined;
      
      
      let scrollPos = {
        left: supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft,
        top: supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop
      };
      let docDimensions = {
        width: supportWindowDimensions ? window.innerWidth : document.documentElement.clientWidth,
        height: supportWindowDimensions ? window.innerHeight : document.documentElement.clientHeight        
      };
      let visibleArea = {
        top: scrollPos.top,
        bottom: scrollPos.top + docDimensions.height,
        left: scrollPos.left,
        right: scrollPos.left + docDimensions.width
      };
            
      return (
          ((elementPosition.top === 0 && visibleArea.top ===0) ||
          (elementPosition.top > 0 && elementPosition.bottom <= visibleArea.bottom))
        &&
          ((elementPosition.left === 0 && visibleArea.left ===0) ||
          (elementPosition.left > 0 && elementPosition.right <= visibleArea.right))
      );
    }
    else {
      let containerDimensions = container.getContentDimensions(); 
    
      let visibleArea = {
        top: containerDimensions.scrollTop,
        bottom: containerDimensions.scrollTop + containerDimensions.contentHeight,
        left: containerDimensions.scrollLeft,
        right: containerDimensions.scrollLeft + containerDimensions.contentWidth
      };
			return (
          ((elementPosition.top === 0 && containerDimensions.scrollTop === 0) ||
          (elementPosition.top > 0 && elementPosition.bottom <= visibleArea.bottom))
        &&
          ((elementPosition.left === 0 && visibleArea.left ===0) ||
          (elementPosition.left > 0 && elementPosition.right <= visibleArea.right))
      );
      
    }
    
  }
  
  public scrollElementIntoView(elementRef: ElementRef, container: Content = null, animate: boolean = true, force: boolean = false) {
    
    if(elementRef === null) return;

    if(!force) {
			let elementIsInView = this.elementIsInView(elementRef, container);
			if(elementIsInView) return;
		}
    
    if(container === null){
      elementRef.nativeElement.scrollIntoView();
    }
    else {
      let elementPosition = this.getElementPos(elementRef);
      container.scrollTo(elementPosition.left, elementPosition.top, animate ? 200: 0);
    }
    
  }
  
  private getElementPos(elementRef: ElementRef){
    return elementRef.nativeElement.getBoundingClientRect();
  }
  
  
}



// WEBPACK FOOTER //
// ./src/helpers/ionic.helper.ts